import Cookies from 'js-cookie';

const DEFAULT_NB_DAY = 28;

// Normalise une valeur numérique (virgule décimale FR → point) et supporte les décimales.
// Ex : "16,5" → 16.5. Renvoie 0 si non numérique (évite les NaN dans les calculs).
function toNum(v) {
    const n = parseFloat(String(v).replace(',', '.'));
    return isNaN(n) ? 0 : n;
}

export default class Order {
    constructor() {
        var cookie = Cookies.get('order', JSON.stringify(this));
        var nbDay = Cookies.get('nbDay');
        this.protPerDayMin = 28;
        Cookies.set('protPerDayMin', this.protPerDayMin);
        this.protPerDayMax = 32;
        Cookies.set('protPerDayMax', this.protPerDayMax);
        this.calPerDayMin = 400;
        Cookies.set('calPerDayMin', this.calPerDayMin);
        this.calPerDayMax = 1000;
        Cookies.set('calPerDayMax', this.calPerDayMax);
        var nbCnoPrescrit = Cookies.get('nbCnoPrescrit');
        this.nbCnoPrescrit = nbCnoPrescrit ? parseInt(nbCnoPrescrit) : 1;

        if (cookie) {
            let currentOrderJSON = JSON.parse(cookie);
            if (nbDay && nbDay > 0) {
                this.nbDay = nbDay;
            }
            if (currentOrderJSON) {
                this.products = currentOrderJSON.products;
                this.nbProduct = currentOrderJSON.nbProduct;
                if (currentOrderJSON.nbCnoPrescrit) {
                    this.nbCnoPrescrit = parseInt(currentOrderJSON.nbCnoPrescrit);
                }
                this.setTotals();
            } else {
                this.products = [];
                this.nbDay = DEFAULT_NB_DAY;
                this.nbProduct = 0;
            }
        } else {
            this.products = [];
            this.nbDay = DEFAULT_NB_DAY;
            this.nbProduct = 0;
        }
        Cookies.set('nbDay', this.nbDay);
    }

    // GETTER
    getJSON() {
        return JSON.stringify(this);
    }
    getNbDay() {
        return this.nbDay;
    }
    getProducts() {
        return this.products;
    }
    getNbProduct() {
        return this.nbProduct;
    }
    getProteine() {
        return this.total_prot;
    }
    getCalorie() {
        return this.total_cal;
    }
    getCno() {
        return this.total_cno.toPrecision(2);
    }
    getProtMin() {
        return this.protPerDayMin * this.nbCnoPrescrit;
    }
    getProtMax() {
        return this.protPerDayMax * this.nbCnoPrescrit;
    }
    getCalMin() {
        return this.calPerDayMin * this.nbCnoPrescrit;
    }
    getCalMax() {
        return this.calPerDayMax * this.nbCnoPrescrit;
    }
    getNbCnoPrescrit() {
        return this.nbCnoPrescrit;
    }

    //SETTER
    setNbDay(nbDay) {
        this.nbDay = nbDay;
        Cookies.set('nbDay', this.nbDay);
        this.save();
    }

    setNbCnoPrescrit(nbCnoPrescrit) {
        this.nbCnoPrescrit = parseInt(nbCnoPrescrit);
        Cookies.set('nbCnoPrescrit', this.nbCnoPrescrit);
        this.save();
    }

    addProduct(postID, proteine, calorie, cno, qty) {
        let product = {};
        product.postID = postID
        product.qty = parseInt(qty);
        product.proteine = toNum(proteine);
        product.calorie = toNum(calorie);
        product.cno = toNum(cno);
        this.products.push(product);
        this.nbProduct++;
        this.save();
    }

    removeProduct(postID, qty = 1) {
        for (let i = 0; i < this.products.length; i++) {
            if (this.products[i].postID == postID) {
                this.products.splice(i, 1);
                this.nbProduct--;
                break;
            }
        };
        this.save();
    }

    setTotals() {
        var totalProt = 0;
        var totalCal = 0;
        var totalCno = 0;
        this.products.forEach(product => {
            // proteine/calorie sont saisies pour une portion → on multiplie par le
            // nombre de portions par pack (cno, éventuellement décimal) pour la valeur par pack.
            totalProt += toNum(product.proteine) * toNum(product.cno);
            totalCal += toNum(product.calorie) * toNum(product.cno);
            totalCno += toNum(product.cno);
        })
        this.total_prot = totalProt;
        this.total_cal = totalCal;
        this.total_cno = totalCno / this.nbDay;
        if (this.total_prot > 0) {
            Cookies.set('total_prot', this.total_prot);
        } else {
            Cookies.set('total_prot', 0);
        }
        if (this.total_cal > 0) {
            Cookies.set('total_cal', this.total_cal);
        } else {
            Cookies.set('total_cal', 0);
        }
        if (this.total_cno > 0) {
            Cookies.set('total_cno', this.total_cno);
        } else {
            Cookies.set('total_cno', 0);
        }
    }
   
    save() {
        // window.localStorage.setItem("order", JSON.stringify(this));
        this.setTotals();
        Cookies.set('order', JSON.stringify(this));
    }
}